import React, { useEffect } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { isAuthed, clearToken } from "@/lib/auth";
import { LayoutDashboard, Ticket, ShoppingBag, ListOrdered, LogOut, CircleDot } from "lucide-react";

export default function AdminLayout() {
  const nav = useNavigate();

  useEffect(() => {
    if (!isAuthed()) nav("/admin/login", { replace: true });
  }, [nav]);

  const link = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 border-l-2 transition-colors font-mono-retro text-xs tracking-[0.2em] uppercase ${
      isActive ? "border-[#C8A96A] text-[#C8A96A] bg-[#1C1816]" : "border-transparent text-[#A8A39D] hover:text-[#F2EBDD]"
    }`;

  return (
    <div data-testid="admin-layout" className="max-w-7xl mx-auto px-6 lg:px-10 py-10 grid grid-cols-1 md:grid-cols-12 gap-8">
      <aside className="md:col-span-3">
        <div className="border border-[#332D2B] bg-[#0F0C0B]">
          <div className="p-5 border-b border-[#332D2B]">
            <div className="font-mono-retro text-[10px] tracking-[0.4em] text-[#C8A96A] uppercase">Boardroom</div>
            <div className="font-display text-2xl text-[#F2EBDD] mt-1">Control Room</div>
          </div>
          <nav className="py-3">
            <NavLink to="/admin" end className={link} data-testid="admin-nav-dashboard">
              <LayoutDashboard size={14} /> Dashboard
            </NavLink>
            <NavLink to="/admin/raffles" className={link} data-testid="admin-nav-raffles">
              <Ticket size={14} /> Raffles
            </NavLink>
            <NavLink to="/admin/jerseys" className={link} data-testid="admin-nav-jerseys">
              <ShoppingBag size={14} /> Jerseys
            </NavLink>
            <NavLink to="/admin/addons" className={link} data-testid="admin-nav-addons">
              <CircleDot size={14} /> Add-Ons
            </NavLink>
            <NavLink to="/admin/orders" className={link} data-testid="admin-nav-orders">
              <ListOrdered size={14} /> Orders
            </NavLink>
            <button
              data-testid="admin-logout"
              onClick={() => { clearToken(); nav("/"); }}
              className="w-full text-left flex items-center gap-3 px-4 py-3 border-l-2 border-transparent text-[#A8A39D] hover:text-[#F2EBDD] font-mono-retro text-xs tracking-[0.2em] uppercase mt-2"
            >
              <LogOut size={14} /> Logout
            </button>
          </nav>
        </div>
      </aside>
      <main className="md:col-span-9">
        <Outlet />
      </main>
    </div>
  );
}
